import { Content, Root, Trigger } from '@latitude/popover';
import { cn } from '@latitude/token-utils';
import type { PopoverLayoutProps } from 'types';

export const PopoverLayout = ({
  children,
  disabled,
  defaultOpen,
  handleOpenOrClose,
  onOpenChange,
  popoverProps,
  popoverContentProps,
  open,
  popoverTrigger,
  'data-testid': testID,
  popoverClassname,
  hideScrollbar,
}: PopoverLayoutProps) => {
  return (
    <Root
      aria-disabled={disabled}
      defaultOpen={disabled ? false : defaultOpen}
      open={disabled ? false : open}
      onOpenChange={(nextOpenState: boolean) => {
        if (disabled) {
          return;
        }
        handleOpenOrClose(nextOpenState);
        onOpenChange?.(nextOpenState);
      }}
      {...popoverProps}
    >
      <Trigger aria-disabled={disabled} asChild data-testid={testID}>
        {popoverTrigger}
      </Trigger>
      <Content
        {...popoverContentProps}
        aria-disabled={disabled}
        {...(testID && { 'data-testid': `${testID}-popover` })}
        className={cn(
          'no-scrollbar',
          hideScrollbar && 'overflow-scroll',
          popoverClassname,
        )}
        style={{
          minWidth: 'var(--radix-popover-trigger-width)',
        }}
      >
        {children}
      </Content>
    </Root>
  );
};
